import styled from 'styled-components';
import {BGImageCenter, dFlex, dFlexCenter, dFlexSpaceBetween, ellipsis, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {whatsApp} from '../../../../assets/symbols/symbols/Symbols.css';

export const card = styled.div`
    width: 181px;
    height: 148px;
    border: 1px solid var(--TA-color-border-subtle);
    border-radius: var(--radius-md);
    background: ${tokens.color.bg.base};
    overflow: hidden;
    box-sizing: border-box;
    ${mobileMedia}{ width: 100%; }
`;

export const body = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: var(--space-lg);
    padding: var(--space-md);
`;

export const header = styled.div`
    ${dFlex};
    align-items: center;
    gap: var(--space-sm);
    height: 44px;
    width: 100%;
`;

export const info = styled.div`
    ${dFlex};
    flex-direction: column;
    flex: 1;
    align-items: flex-end;
    text-align: start;
    min-width: 0;
    line-height: 16px;
`;

export const name = styled.p`
    margin: 0;
    width: 100%;
    font-size: ${tokens.typography.fontSize.body};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 1.4;
    color: var(--TA-color-text-default);
    ${ellipsis};
`;

export const conference = styled.p`
    margin: 0;
    width: 100%;
    font-size: ${tokens.typography.fontSize.buttonChip};
    font-weight: ${tokens.typography.fontWeight.regular};
    color: var(--TA-color-text-default);
    ${ellipsis};
`;

export const avatar = styled.div<{ $image?: string }>`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: var(--TA-color-bg-surface-default, #0000000d);
    ${p => p.$image && BGImageCenter(p.$image, 'cover')}
`;

export const footer = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: var(--space-xs);
    width: 100%;
`;

export const footerRow = styled.div`
    ${dFlexSpaceBetween};
    width: 100%;
`;

export const endedText = styled.p`
    margin: 0;
    font-size: ${tokens.typography.fontSize.caption};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 1.1;
    color: var(--TA-color-text-subtle, rgba(0, 0, 0, 0.4));
    white-space: nowrap;
`;

export const assignButton = styled.button`
    ${dFlexCenter};
    width: 100%;
    height: 28px;
    padding: 0 var(--space-lg);
    border: none;
    border-radius: var(--radius-full);
    background: var(--TA-color-bg-surface-default, #0000000d);
    cursor: pointer;
    font-size: ${tokens.typography.fontSize.buttonChip};
    font-weight: ${tokens.typography.fontWeight.bold};
    line-height: 16px;
    color: var(--TA-color-text-default);
    white-space: nowrap;
    transition: background 150ms;
    &:hover { background: var(--TA-color-bg-surface-hover, rgba(0, 0, 0, 0.1)); }
`;

export const whatsAppIcon = styled.div`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    ${BGImageCenter(whatsApp, 'contain')}
`;

export const contactButton = styled.button`
    ${dFlexCenter};
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;
    flex-shrink: 0;
    margin-inline-start: auto;
    transition: background 150ms;
    &:not(:disabled):hover {
        background: var(--TA-color-bg-surface-hover, rgba(0, 0, 0, 0.1));
    }
    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
